import { usePostHog } from 'posthog-js/react'
import { useEffect } from 'react'

/**
 * Automatically manages PostHog session recording based on visibility changes.
 */
export function PostHogVisibilityManager(): React.ReactNode {
  const posthog = usePostHog()

  // Handle visibility changes to pause/resume recording
  useEffect(() => {
    const handleVisibilityChange = () => {
      try {
        if (document.hidden) {
          if (posthog.sessionRecordingStarted()) {
            posthog.stopSessionRecording()
          }
        }
        else {
          if (!posthog.sessionRecordingStarted()) {
            posthog.startSessionRecording()
          }
        }
      }
      catch {
        // rrweb (used by PostHog for session recording) may throw SecurityError
        // when accessing cross-origin iframes during start/stop.
        // This is benign — the recording state is still consistent.
      }
    }

    document.addEventListener('visibilitychange', handleVisibilityChange)

    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange)
    }
  }, [posthog])

  return undefined
}
